// extracted by mini-css-extract-plugin
export default {"container":"Interactions_container__as0zE","innerContainer":"Interactions_innerContainer__orov6"};